export const IMPORT_NHSNUMBER_UPLOAD_REQUEST = "IMPORT_NHSNUMBER_UPLOAD_REQUEST"
export const IMPORT_NHSNUMBER_UPLOAD_RECEIVE = "IMPORT_NHSNUMBER_UPLOAD_RECEIVE"
export const IMPORT_NHSNUMBER_UPLOAD_FAILURE = "IMPORT_NHSNUMBER_UPLOAD_FAILURE"
